import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from "vue";
import { useAppStore } from "@/stores/app";
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";
//@ts-ignore
import HamburgerButton from "@/components/elements/hamburger-button.vue";

interface Link {
    link: {
        class: string;
        target: string;
        title: string;
        url: string;
    };
}


export default /*#__PURE__*/_defineComponent({
  props: {
    links: { type: Array, required: false },
    uri: { type: String, required: true },
    contactLinks: { type: Array, required: false },
    firstSection: { type: Object, required: false }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as { links?: Link[]; uri: string; contactLinks?: Link[]; firstSection?: { bg_color: string } }

const breakpoints = useBreakpoints(breakpointsTailwind);

const showPageLinks = breakpoints.greater("lg");
const showHamburgerButton = breakpoints.smaller("lg");

const appStore = useAppStore();



const isActive = (link: string) => {
    if(link === '/wonen' && props.uri.includes('panden')){
        return true;
    }

    if(link === '/projecten' && props.uri.includes('projecten/')){
        return true;
    }
    
    return (props.uri !== "/" && link.includes(props.uri)) || (props.uri === "/" && link === "/");
};

onMounted(() => {
    let last_known_scroll_position = 0;
    let ticking = false;

    window.addEventListener("scroll", function () {
        last_known_scroll_position = window.scrollY;	

        if (!ticking) {
            window.requestAnimationFrame(function () {
                if (last_known_scroll_position > 50) {
                    appStore.navigation.header.sticky = true;
                } else {
                    appStore.navigation.header.sticky = false;
                }

                ticking = false;
            });

            ticking = true;
        }
    });
});

const __returned__ = { breakpoints, showPageLinks, showHamburgerButton, appStore, props, isActive, HamburgerButton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})